//shim for jQuery that does nothing, but satisfies our horrible login code

define('comments/jqueryish',[],function() {
  var noop = function() {};
  return function() {
    return {
      bind: noop,
      ready: function(f) { f() },
      append: noop,
      removeClass: noop,
      html: noop
    }
  }
});
